import { useReactiveVar } from "@apollo/client";
import React from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { isShareEventModalVar } from "../../../graphql/globalVar/state";

import ShareButton from "./components/shareButton";
import { SOCIAL_NETWORKS } from "./constants";

function ShareEventModal() {
  const data = useReactiveVar(isShareEventModalVar);
  const { t } = useTranslation();

  return (
    <Modal
      show={!!data}
      onHide={() => isShareEventModalVar(null)}
      centered
      dialogClassName="modal-share-event"
      contentClassName="rounded-4 border-0"
    >
      <Modal.Header closeButton className="border-0 pe-3 pt-3 pb-0" />
      <Modal.Body className="text-center p-3 pt-2">
        <h4 className="fs-4 text-dark fw-bold mb-1">
          {t("events.modals.share.title")}
        </h4>
        <p className="fs-6 mb-4 px-4 px-md-0">
          {data?.title} <span className="mx-2">•</span> {data?.date}
        </p>
        <div className="share-event-networks">
          <Row className="g-md-2">
            {SOCIAL_NETWORKS(data?.url ?? "").map(({ img, labelKey, href }) => (
              <Col key={labelKey} xs={12} md={6}>
                <ShareButton
                  img={img}
                  label={t(`events.modals.share.${labelKey}`)}
                  href={href}
                />
              </Col>
            ))}
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ShareEventModal;
